import React from 'react'
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import {withStyles} from "@material-ui/core";
import {Styles} from "../../../../config/design/styles";
import {Translate} from "../../../../config/Translate";

import FileManager from "../FileManager";
import {defaultVariabls} from "../../../../config/index";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class FileManagerDialog extends React.Component{
    state = {
        open: true
    };
    classes = this.props.classes;
    size = this.props.size ? this.props.size: 200;
    image_ = this.size > 400 ? "_medium" : "_small";
    handleSetImage(data){
        let res ={
            src:data.source,
            alt:data.alt,
            id:data.id,
            thumbSource: `${defaultVariabls.uploads}/FileManager/${data.ImageName}${this.image_}.${data.extension}`
        };
        if(this.props.setData !== undefined){
            this.props.setData(data)
        }else{
            this.props.setImage(res);

        }
    }
    handleClose = () => {
        this.setState({
            open:false
        });
        this.props.cancleOperation();
    };
    render(){
        let {open} = this.state;
        return(
            <div>
                <Dialog fullWidth={true} maxWidth={"lg"} open={open} onClose={this.handleClose} TransitionComponent={Transition} >
                    <AppBar className={this.classes.appBarDialog}>
                        <Toolbar>
                            <Typography variant="h6" className={this.classes.titleDialog}>
                                {Translate.chooseMedia}
                            </Typography>
                            <IconButton color="inherit" onClick={this.handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <div style={{padding:20}}>
                    <FileManager selection={this.props.selection === true} multiInsert={this.props.multiInsert === true} fileType={this.props.fileType} handleSetImage={this.handleSetImage.bind(this)}/>
                    </div>
                </Dialog>
            </div>
        )
    }
}
export default  withStyles(Styles)(FileManagerDialog)